import { CircularProgress, Grid2 } from "@mui/material";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
// styles
import styles from "./CreateBlueprint.module.scss";
// Local import
import Dropdown from "../../../../../../GlobalComponents/Dropdown/Dropdown";
import CustomInput from "../../../../../../GlobalComponents/CustomInput/CustomInput";
import ImageUploader from "../../../../../../GlobalComponents/ImageUploader/ImageUploader";
import { useEffect } from "react";
import { Actions } from "../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../Utils/storeUtils";

export default function CreateBlueprint(props) {
  const {
    createBluePrintForm,
    setCreateBlueprintForm,
    nameLoading,
    nameValid,
    values,
    setValues,
    image,
    setImage,
    fileInputRef,
    resetImageState,
    sitesInfo,
    errorMessage,
    setErrorMessage,
  } = props;

  let arnInfo = sitesInfo.siteArns || {};

  // a v2 (EBS) site has no EFS storage to make a blueprint from
  const allSites = sitesInfo?.sitesList?.data
    ?.filter((site) => site?.ebsSite !== true)
    .map((name) => name.siteName);

  const formattedSites = allSites?.map((site) => ({
    label: site,
    value: site,
  }));

  useEffect(() => {
    if (arnInfo && createBluePrintForm.siteId !== "") {
      const siteId = createBluePrintForm.siteId;
      const siteData = arnInfo[siteId];
      if (siteData === false) {
        setErrorMessage("Oops! site is down");
      } else if (siteData === undefined) {
        getStore().dispatch({
          type: Actions.API_SITES_LB_ARN,
          data: {
            siteName: createBluePrintForm.siteName,
            siteId: createBluePrintForm.siteId,
          },
        });
      } else {
        setErrorMessage("");
      }
    }
  }, [arnInfo, createBluePrintForm.siteId]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setValues({ ...values, image: file });
    setImage(URL.createObjectURL(file));
    setCreateBlueprintForm({
      ...createBluePrintForm,
      file: file,
    });
    fileInputRef.current.value = "";
  };

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleDeleteImage = () => {
    resetImageState();
    setValues({ ...values, image: null });
    setCreateBlueprintForm({ ...createBluePrintForm, file: null });
  };

  return (
    <>
      <Grid2 className={styles.createBlueprint}>
        <Grid2 className={styles.height}>
          <Dropdown
            options={formattedSites}
            title="Select Site"
            placeholder="Select Your Site"
            value={createBluePrintForm?.siteId}
            onSelect={(opt) => {
              setCreateBlueprintForm({
                ...createBluePrintForm,
                siteName: opt,
                siteId: opt,
                siteInstallType: opt,
              });
            }}
            dropdownHeader={styles.dropdownList}
            error={!!errorMessage || formattedSites?.length === 0}
            errorMessage={
              formattedSites?.length === 0 ? "No Site Found" : errorMessage
            }
          />
          <CustomInput
            title="Blueprint Nickname"
            placeholder="Enter your Blueprint Name"
            value={createBluePrintForm?.name}
            setValue={(value) => {
              const startsWithNonDigit = /^[^0-9]/;
              if (value !== "" && !startsWithNonDigit.test(value)) {
                return;
              }
              let formattedValue = value
                .toLowerCase()
                .replace(/[^a-zA-Z0-9]/g, "");
              if (formattedValue?.length > 25) {
                formattedValue = formattedValue.substr(0, 25);
              }
              setCreateBlueprintForm((prev) => ({
                ...prev,
                name: formattedValue,
                newName: null,
                newNameErrorMessage: null,
              }));
            }}
            required={true}
            error={
              (createBluePrintForm?.name?.length > 0 &&
                createBluePrintForm?.name?.length <= 3) ||
              createBluePrintForm?.name?.length >= 25 ||
              !!createBluePrintForm?.newNameErrorMessage
            }
            errorMessage={
              createBluePrintForm?.name?.length > 0 &&
              createBluePrintForm?.name?.length <= 3
                ? "blueprint name must be above " + 3 + " characters"
                : createBluePrintForm?.name.length >= 25
                ? "blueprint name should not exceed 24 letters"
                : createBluePrintForm?.newNameErrorMessage
            }
            nameLoading={nameLoading}
            suffix={
              createBluePrintForm?.name.length > 0 ? (
                nameLoading ? (
                  <CircularProgress size={20} />
                ) : nameValid ? (
                  <CheckCircleOutlineOutlinedIcon
                    className={styles.iconSuccess}
                  />
                ) : nameValid === false ? (
                  <HighlightOffIcon className={styles.iconError} />
                ) : null
              ) : null
            }
          />
          <Grid2 className={styles.uploadImage}>Upload Image</Grid2>
          <ImageUploader
            imagePreview={image}
            defaultImage="/path/to/default/image.jpg"
            isDeleting={false}
            onDelete={handleDeleteImage}
            onUploadClick={handleImageClick}
            onFileChange={handleFileChange}
            fileInputRef={fileInputRef}
          />
        </Grid2>
      </Grid2>
    </>
  );
}
